'use strict';
const pushDataLayer = require('../../src/js/modules/helpers/analyticsHelper');

function openFooterAccordion() {
    const $footerHiddenColumns = $('.js-accordion-inner:nth-child(n+6)');
    const $footerHiddenLinks = $('.js-accordion-content-inner li:nth-child(n+4)');
    const $footerMiddleElements = $('.js-footer-middle-elements');

    $(document).on('mouseover', '.js-footer-accordion', function() {
        $footerHiddenLinks.addClass('visible');
        $footerHiddenColumns.addClass('visible');
        $footerMiddleElements.addClass('slide');
    });
}

function sendAnalyticsEvent() {
  const items = $('.accordion-content li');

  items.on('click', function (e) {
    e.stopPropagation();
    const footerItemText = $(this).find('a').text().trim();
    pushDataLayer({
      event: 'menu_navigation',
      menu: 'footer',
      menu_path: `Footer, ${footerItemText}`.toLowerCase(),
      menu_text: footerItemText.toLowerCase(),
      menu_click: 'text'
    });
  });

  const icons = $('.social--icons li a');
  icons.on('click', function (e) {
    e.stopPropagation();
    const footerIconText = $(this).attr('alt').replace('logo ', '');

    pushDataLayer({
      event: 'menu_navigation',
      menu: 'footer',
      menu_path: `Footer, ${footerIconText}`.toLowerCase(),
      menu_text: footerIconText.toLowerCase(),
      menu_click: 'picture'
    });
  });
}

function initializeEvents() {
    openFooterAccordion();
    sendAnalyticsEvent();
}

const footer = {
  init: function() {
    initializeEvents();
  }
};

module.exports = footer;
